//@flow
import { graphql } from 'react-relay';
import { generateMutation } from './generateMutation';

import type { OutputType } from './generateMutation';

const taggedQuery = graphql`
    mutation followPageMutation($input: FavoritePageInput!) {
        favoritePage(input: $input) {
            user {
                favorites(types: [DESIGNER]) {
                    edges {
                        node {
                            serviceId
                            anchor {
                                sourceId
                            }
                        }
                    }
                }
            }
        }
    }
`;

type Args = {|
    page: string, // url label of the firm
    type: 'DESIGNER',
    userId: string,
    favoriteId: string,
    action: 'ADD' | 'REMOVE',
|};

export const followPage: (Object, Args) => Promise<OutputType> = generateMutation(taggedQuery);
